import * as React from 'react';

import { DragSourceMonitor, useDragLayer, XYCoord } from 'react-dnd';
import { DragDropItemType } from './DraggablePhotoTile';
import PhotoTilePreview from './PhotoTilePreview';

const previewItemStyle = (
	initialOffset: XYCoord | null,
	currentOffset: XYCoord | null,
) => {
	// With a custom drag layer, we are responsible for handling the preview position.
	// This seems like an awkward limitation of the library
	if (!initialOffset || !currentOffset) return { display: 'none' };

	const { x, y } = currentOffset;

	const transform = `translate(${x}px, ${y}px)`;

	return {
		transform,
		WebkitTransform: transform
	};
};

const PhotoTileDragLayer: React.FC = () => {
	const {
		itemType,
		isDragging,
		item,
		initialOffset,
		currentOffset,
	} = useDragLayer((monitor: DragSourceMonitor) => ({
		item: monitor.getItem(),
		itemType: monitor.getItemType(),
		initialOffset: monitor.getInitialSourceClientOffset(),
		currentOffset: monitor.getSourceClientOffset(),
		isDragging: monitor.isDragging()
	}));

	if (!isDragging || itemType !== DragDropItemType.TILE) return null;

	return <div className="drag-layer">
		<div style={previewItemStyle(initialOffset, currentOffset)}>
			<PhotoTilePreview {...item.tile} target={item.target} />
		</div>
	</div>;
};

export default PhotoTileDragLayer;
